
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a"}},[_c('feColorMatrix',{attrs:{"in":"SourceGraphic","values":"0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"}})])]),_c('g',{attrs:{"filter":"url(#a)","transform":"translate(-8 -7)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#252626","fill-rule":"nonzero","d":"M21 20.67l1.44-1.45a.5.5 0 01.71 0l.7.71a.5.5 0 010 .71l-3.13 3.14a.751.751 0 01-.53.22h-.38a.77.77 0 01-.53-.22l-3.13-3.13a.5.5 0 010-.71l.71-.71a.49.49 0 01.7 0L19 20.67V12a1 1 0 011-1h7a2 2 0 012 2v14a2 2 0 01-2 2H13a2 2 0 01-2-2V13a2 2 0 012-2v16h14V13h-6.001L21 20.67z"}})])])
          )
        }
      }
    